export const ALLOWED_ROLES = ["active"];
export const FORBIDDEN_ROLES = ["blocked"];
